module.exports = __webpack_public_path__ + "img/zoetrope1.216eef68.jpg";